import { CrewMember } from '@bechtel/types';

export interface RodRoomAttendantSelectorProps {
  onRodRoomAttendantSelection: (selectedItem: CrewMember) => void;
  selectedItem?: CrewMember;
}
